import React from 'react'
import { connect } from 'react-redux'
import { Location, Navigate, NavigateFunction, Route, useLocation, useNavigate } from 'react-router-dom'

import { fromJS } from 'immutable'
import * as _ from 'lodash-es'
import { bindActionCreators } from 'redux'

import NavButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/navButton/NavButton'
import BootstrapContainer from '@lyrahealth-inc/ui-core/lib/molecules/layouts/bootstrapContainer/BootstrapContainer'

import PracticeProviders from './providers/PracticeProviders'
import styles from './providersPracticeDetails.module.scss'
import TabFilters from '../../../common/components/tabFilters/TabFilters'
import {
  PRACTICES,
  PRACTICES_DETAILS_EDIT_INFO,
  PRACTICES_DETAILS_INFO,
  PRACTICES_DETAILS_PROVIDERS,
} from '../../../common/constants/routingConstants'
import { RootState } from '../../../data/store'
import { SentryRoutes } from '../../../index'
import * as practiceDetailsActions from '../data/practiceDetailsActions'
// pages
import { getPracticeDetailsData } from '../data/practiceDetailsSelectors'
import DisplayPracticeInfo from '../info/DisplayPracticeInfo'
import EditPracticeInfo from '../info/EditPracticeInfo'

type ProvidersPracticeDetailsProps = {
  navigate: NavigateFunction
  location: Location
  actions?: any
  practiceDetails?: any // TODO: PropTypes.instanceOf(Map)
}

class ProvidersPracticeDetails extends React.Component<ProvidersPracticeDetailsProps> {
  componentDidMount() {
    const { navigate, location, practiceDetails, actions } = this.props
    const practiceId = location.state && location.state.practiceId
    if (!practiceDetails) {
      if (practiceId) {
        return actions.getPractice(practiceId)
      }
      // we don't have the context for what practice we should fetch/display,
      // so punt them back to the practices list
      return navigate(PRACTICES.route, { replace: true })
    }
  }

  componentWillUnmount() {
    this.props.actions.clearPracticeDetailsStore()
  }

  _backToPractices = () => {
    this.props.navigate(PRACTICES.route)
  }

  _handleTabClick = (tab: any) => {
    switch (tab.toLowerCase()) {
      case 'providers':
        this.props.navigate(PRACTICES_DETAILS_PROVIDERS.route, { replace: true })
        break
      case 'info':
        this.props.navigate(PRACTICES_DETAILS_INFO.route, { replace: true })
        break
    }
  }

  _renderTabs = () => {
    let tab
    const pathname = this.props.location.pathname
    if (_.includes(pathname, 'info')) {
      tab = 'Info'
    } else if (_.includes(pathname, 'providers')) {
      tab = 'Providers'
    }

    // @ts-expect-error TS(2322): Type '(tab: any) => void' is not assignable to typ... Remove this comment to see the full error message
    return <TabFilters activeTab={tab} tabList={['INFO', 'PROVIDERS']} handleClick={this._handleTabClick} />
  }

  render() {
    if (!this.props.practiceDetails) {
      return false
    }

    const { practiceDetails } = this.props

    return (
      <BootstrapContainer>
        <NavButton
          // @ts-expect-error TS(2322): Type '{ className: string; styleType: string; text... Remove this comment to see the full error message
          className={styles['back-button']}
          styleType='back'
          text='Back to Practices'
          onClick={this._backToPractices}
        />
        <div className={styles.overview}>
          <h2>{practiceDetails.practice_name}</h2>
          <p>{practiceDetails.email}</p>
        </div>
        {this._renderTabs()}
        <SentryRoutes>
          <Route
            path={PRACTICES_DETAILS_EDIT_INFO.subroute}
            element={<EditPracticeInfo initialValues={fromJS(practiceDetails)} />}
          />
          <Route path={PRACTICES_DETAILS_INFO.subroute} element={<DisplayPracticeInfo data={practiceDetails} />} />
          <Route
            path={PRACTICES_DETAILS_PROVIDERS.subroute}
            element={<PracticeProviders practiceID={practiceDetails.id} />}
          />
          <Route path='*' element={<Navigate to={PRACTICES_DETAILS_INFO.route} />} />
        </SentryRoutes>
      </BootstrapContainer>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    practiceDetails: getPracticeDetailsData(state),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ ...practiceDetailsActions }, dispatch),
  }
}

const ConnectedProvidersPracticeDetails = connect(mapStateToProps, mapDispatchToProps)(ProvidersPracticeDetails)

export default function ProvidersPracticeDetailsWithRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  return <ConnectedProvidersPracticeDetails navigate={navigate} location={location} />
}
